/**
 * Flags de funcionalidade controladas pela tabela Parameter da API.
 * Para criar uma nova: adicione a chave aqui E em `ParameterKeys.PublicFlagKeys` (API),
 * senão o backend a restringe a AdminRenova em `GET parameter/get/{chave}`.
 * Regra do backend: ausente ou qualquer valor diferente de "false" = ligada.
 */
export const FEATURE_FLAGS = {
  NFSE: { key: "NFSE_AUTO_EMISSION_ENABLED", label: "NFS-e" },
} as const;

export type FeatureFlagName = keyof typeof FEATURE_FLAGS;
